import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from "react";
import { publicBrandStatus, type BrandStatus } from "../api/brand";

const Ctx = createContext<{ status: BrandStatus | null; refresh: () => void }>({ status: null, refresh: () => undefined });

export function BrandStatusProvider({ children }: { children: ReactNode }) {
  const [status, setStatus] = useState<BrandStatus | null>(null);
  const load = useCallback((fresh = false) => { publicBrandStatus(fresh).then(setStatus); }, []);
  useEffect(() => load(), [load]);
  const refresh = useCallback(() => load(true), [load]);
  return <Ctx.Provider value={{ status, refresh }}>{children}</Ctx.Provider>;
}

export const useBrandStatus = () => useContext(Ctx);
